import { fancyTimeFormat, fancyTimeFormatWithHM } from '../components/timeHelper';

// Episode actions use timeline time, independent of the selected playback rate.
export const episodePlaybackLabel = (totalSeconds, startSeconds = 0, continuing = false, explicitStart = false) => {
    const duration = Number(totalSeconds);
    const position = Number(startSeconds);
    const boundedPosition = Number.isFinite(position) ? Math.max(0, position) : 0;
    if (explicitStart) {
        const time = fancyTimeFormat(boundedPosition);
        return { title: `Play from ${time}`, accessibilityLabel: `Play episode from ${time}` };
    }
    const isContinuation = continuing || boundedPosition > 0;
    const action = isContinuation ? 'Continue episode' : 'Play episode';
    if (!Number.isFinite(duration) || duration <= 0 || startSeconds === null || !Number.isFinite(position)) {
        return { title: action, accessibilityLabel: action };
    }

    const seconds = Math.max(0, duration - Math.min(boundedPosition, duration));
    const time = seconds === 0 ? '<1m' : fancyTimeFormatWithHM(seconds);
    const spokenTime = time === '<1m' ? 'less than 1 min' : time
        .replace(/h\b/g, ' hr')
        .replace(/m\b/g, ' min')
        .replace(/s\b/g, ' sec');
    const title = `${time}${isContinuation ? ' left' : ''}`;
    return {
        title,
        accessibilityLabel: `${action}, ${spokenTime}${isContinuation ? ' left' : ''}`,
    };
};

export const firstEpisodeDuration = (...durations) => durations.map(Number)
    .find(duration => Number.isFinite(duration) && duration > 0);

// Keep preview action copy aligned with the exact position handed to the episode.
export const previewContinuationSeconds = (startSeconds, elapsedSeconds, clipDuration) => {
    const start = Number(startSeconds);
    if (startSeconds === null || !Number.isFinite(start) || !Number.isFinite(elapsedSeconds)) return null;
    const duration = Number(clipDuration);
    const elapsed = Math.max(elapsedSeconds, 0);
    return Math.max(start, 0) + Math.min(elapsed,
        Number.isFinite(duration) && duration > 0 ? duration : elapsed);
};
